import { css, CSSResultGroup, html, LitElement, TemplateResult } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { userForm } from "../types/game-parent.types";
import { CookieManager, User } from "../classes/class-user";
import { cookieObject } from "../types/game-start-screen.types";
import { loginRequestObject, responseObject } from "../classes/types/class-user.types";

@customElement("game-start-screen")
export class GameStartScreen extends LitElement {
    @state()
    private formState: string = "login";
    private formError: string | null = "";
    private userLoggedIn: boolean = false;

    @property({ type: String }) public sessionUserId = "0";
    @property({ type: Boolean }) public userPlayedBefore = true;
    @property({ type: Boolean }) public isUserInGame = false;

    public connectedCallback(): void {
        // Calls superclass connectedCallback
        super.connectedCallback();
    }

    public static styles: CSSResultGroup = css`
        * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
        }

        .main {
            display: flex;
            flex-direction: column;
            max-width: 100%;
        }

        .main-box {
            position: relative;
            display: flex;
            flex-direction: column;
            height: 100vh;
            padding: 2em;
            gap: 1em;
            background-color: transparent;
        }

        h2 {
            text-align: center;
            padding-bottom: 1em;
            font-size: 4rem;
        }

        button {
            border: 0;
        }

        .start-intro-text {
            border: 4px solid black;
            padding: 2em;
            font-size: 1.4rem;
            background-color: #334155eb;
            max-width: 70%;
        }

        .div-main-text {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .div-buttons {
            display: flex;
            flex-direction: column;
            gap: 0.6em;
        }

        .div-buttons-primary {
            justify-content: center;
            min-width: 12em;
            margin: auto;
            padding-top: 2em;
        }

        .div-buttons-secondary {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-top: auto;
        }

        .div-buttons-mainmenu {
            display: flex;
            flex-direction: column;
            margin: auto;
            gap: 2em;
        }

        .content {
            flex-grow: 1;
        }

        .button-login {
            background-color: white;
        }

        .button-register {
            background-color: #cbd5e1;
        }

        .button-logout {
            padding: 2em;
            float: right;
        }

        form {
            display: flex;
            flex-direction: column;
            padding-bottom: 1em;
            background-color: #cbd5e180;
            border-radius: 10px;
            margin-left: auto;
            margin-right: auto;
            padding-left: 2em;
            padding-right: 2em;
            margin-top: 2em;
        }

        .div-input {
            display: flex;
            flex-direction: column;
            gap: 0.6em;
            margin: auto;
            width: 24em;
        }

        input {
            padding: 0.6em;
            border-radius: 10px;
            font-size: 1rem;
            font-weight: 600;
        }

        input:focus {
            outline: 1px solid #cbd5e1;
        }

        label {
            padding-top: 0.4em;
            font-size: 1.8rem;
            font-weight: 700;
        }

        button {
            padding: 0.8em;
            border-radius: 12px;
            cursor: pointer;
        }

        button:hover {
            background-color: #64748b;
        }

        .message-form-error {
            color: red;
        }

        .background-image {
            position: absolute;
            width: 100%;
            height: 100vh;
            z-index: -999;
            pointer-events: none;
            align-self: center;
            object-fit: cover;
        }

        @media (min-width: 1920px) {
            .background-image {
                width: 1600px;
            }
        }
    `;

    // HTML for main menu interface as placeholder
    private get _userMainMenuInterface(): TemplateResult {
        return html`<div class="div-buttons-mainmenu">
            ${this.userPlayedBefore === true
                ? html`<button @click=${this._handleClickContinueGame} type="button" class="button-logout">
                      Continue game
                  </button>`
                : html`<button @click=${this._handleClickStartGame} type="button" class="button-logout">
                      Start new game
                  </button>`}
            <button @click=${this._handleClickResetGame} type="button" class="button-logout">
                Reset game progress
            </button>
        </div>`;
    }

    public render(): TemplateResult<1> {
        return html`
            <section class="main">
                <div class="main-box">
                    ${this.userLoggedIn === true
                        ? html`<button @click=${this._handleClickLogout} type="button" class="button-logout">
                              Logout
                          </button>`
                        : html``}
                    <div class="div-main-text">
                        <h2>The Game</h2>
                        <p class="start-intro-text">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem sapiente eligendi
                            repellat placeat quaerat maxime corporis error soluta, repellendus ratione! Nobis
                            doloribus voluptatem sunt vitae iusto ab, consequuntur nisi ipsa. Ab atque
                            numquam, iusto sapiente necessitatibus ut ratione, sunt maiores eos cupiditate,
                            blanditiis nemo reprehenderit aliquid animi doloremque labore quod.
                        </p>
                    </div>
                    ${this.userLoggedIn === true
                        ? html`${this._userMainMenuInterface}`
                        : html`<form @submit=${this._handleStartFormSubmit}>
                              <div class="div-input">
                                  <label for="username">Username</label>
                                  <input
                                      type="text"
                                      id="username"
                                      placeholder="Username"
                                      minlength="1"
                                      required
                                  />
                              </div>
                              <div class="div-input">
                                  <label for="password">Password</label>
                                  <input
                                      type="password"
                                      id="password"
                                      placeholder="Password"
                                      minlength="3"
                                      required
                                  />
                              </div>
                              ${this.formState === "login"
                                  ? html``
                                  : html` <div class="div-input">
                                        <label for="passwordConfirm">Password confirm</label>
                                        <input
                                            type="password"
                                            id="passwordConfirm"
                                            placeholder="Password confirm"
                                            minlength="3"
                                            required
                                        />
                                    </div>`}
                              ${this.formState === "login"
                                  ? html` <p class="message-form-error">${this.formError}</p>
                                        <div class="div-buttons div-buttons-primary">
                                            <button type="submit" class="button button-login">Login</button>
                                            <button
                                                type="button"
                                                class="button button-register"
                                                @click=${this._handleClickRegister}
                                            >
                                                Register
                                            </button>
                                        </div>`
                                  : html` <p class="message-form-error">${this.formError}</p>
                                        <div class="div-buttons div-buttons-primary">
                                            <button type="submit" class="button button-login">Proceed</button>
                                            <button
                                                type="submit"
                                                class="button button-register"
                                                @click=${this._handleClickLogin}
                                            >
                                                To login
                                            </button>
                                        </div>`}
                          </form>`}

                    <div class="div-buttons div-buttons-secondary">
                        <button type="button" class="button-credits">Credits</button>
                        <button type="button" class="button-help">Help</button>
                    </div>
                </div>
                <img
                    src="./images/hotel.jpg"
                    alt="404- Background image not found"
                    class="background-image"
                />
            </section>
        `;
    }

    private _handleClickRegister(): void {
        this.formState = "register";
    }

    private _handleClickLogin(): void {
        this.formState = "login";
    }

    private _handleClickLogout(): void {
        this.userLoggedIn = false;
        this.sessionUserId = "";
        this.formError = "";

        const userClass: User = new User("", "", "");

        userClass.removeLoggedInUser();

        this.dispatchEvent(new Event("user-change"));
    }

    private async _handleClickStartGame(): Promise<void> {
        const userClass: User = new User(this.sessionUserId, "", "");

        const result: void = await userClass.startGameForUser();
        console.log(result);

        this.isUserInGame = true;
        this.dispatchEvent(new Event("go-ingame"));
    }

    private _handleClickContinueGame(): void {
        this.isUserInGame = true;
        this.dispatchEvent(new Event("go-ingame"));
    }

    private async _handleClickResetGame(): Promise<void> {
        const userClass: User = new User(this.sessionUserId, "", "");

        const result: void = await userClass.resetGameProgressForUser();
        console.log(result);
        this.userPlayedBefore = false;
    }

    private async _handleStartFormSubmit(event: Event): Promise<void> {
        event.preventDefault();

        const form: HTMLFormElement = event.target as HTMLFormElement;
        const formData: userForm = {
            username: form["username"].value,
            password: form["password"].value,
            passwordConfirm: "",
        };

        if (form["passwordConfirm"]) {
            formData.passwordConfirm = form["passwordConfirm"].value;
        }

        // Form is a register form
        if (this.formState === "register") {
            // error message, input fields have property required to negate though.
            if (!formData.username.length || !formData.password.length || !formData.passwordConfirm?.length) {
                this.formError = "Please fill in all the required fields";
            }

            if (formData.password !== formData.passwordConfirm) {
                this.formError = "Passwords do not match, please try again.";
                this.requestUpdate();
            }

            const userRegisterClass: User = new User("", formData.username, formData.password);

            const result: responseObject | null = await userRegisterClass.createNewUser(
                formData.username,
                formData.password
            );

            // Result is null which in this case is succes with no errors
            if (!result) {
                alert("Your account has been created, you can now login.");
                this.formError = "";
                this.formState = "login";
                return;
            }

            if (result.status === 400) {
                this.formError = result.error;
                this.requestUpdate();
                this.formState = "register";
                // there was an issue with the login request, do no proceed past this line.
                return;
            }

            // Marks the end of the register form
            return;
        }

        // Is login form
        const userClass: User = new User(this.sessionUserId, formData.username, formData.password);

        const result: loginRequestObject = await userClass.setloggedInUser();

        if (result.error) {
            this.formError = result.error;
            this.requestUpdate();
            // there was an issue with the login request, do no proceed past this line.
            return;
        }

        const cookie: cookieObject = CookieManager.getUserCookie();

        if (!cookie.userId) {
            // No user session active
            this.userLoggedIn = false;
        }

        if (cookie.userId) {
            this.userLoggedIn = true;
            // Actively keeps track of the logged in user
            this.sessionUserId = cookie.userId;
            // dispatch login / cookie set event
            this.dispatchEvent(new Event("user-change"));
        }

        // Keeps track of user's game status if the user returns to the main menu.
        await this.getUserGameSaveStatus();
    }

    private async getUserGameSaveStatus(): Promise<void> {
        const userClass: User = new User(this.sessionUserId, "", "");
        // Check game_started of the current logged in user.
        const userGameStatus: boolean = await userClass.getGameStartedStatus();

        if (userGameStatus === true) {
            this.userPlayedBefore = true;
        } else {
            this.userPlayedBefore = false;
        }

        console.log(this.userPlayedBefore);
    }

    public updated(): void {
        console.log("Start screen update triggered");

        // Check if there is a user logged in, redirects to the correct page.
        const cookie: cookieObject = CookieManager.getUserCookie();
        if (cookie.userId) {
            this.userLoggedIn = true;
            // Actively keeps track of the logged in user
            this.sessionUserId = cookie.userId;
            // dispatch login / cookie set event
            this.dispatchEvent(new Event("user-change"));
        }
    }
}
